exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer-mobile{padding:15px}.footer-mobile .top-left-footer{width:100%}.footer-mobile .top-left-footer .logo{display:inline-block;width:calc(50% - 3px);font-size:11px;color:rgba(0,0,0,.502)}.footer-mobile .top-left-footer .logo svg{width:50px;float:left}.footer-mobile .top-left-footer .logo div{position:relative;top:3px;float:left;width:59px;font-weight:700;padding-left:5px}.footer-mobile .top-left-footer .social{position:relative;top:-15px;display:inline-block;width:calc(50% - 2px);text-align:right}.footer-mobile .top-left-footer .social svg{width:15px;height:15px}.footer-mobile .top-left-footer .social li{margin-left:7px;list-style:none;display:inline}.footer-mobile .top-left-footer .social li a{text-decoration:none}.footer-mobile .bottom-left-footer{display:inline-block;width:100%}.footer-mobile .bottom-left-footer div{text-align:center;line-height:17px}.footer-mobile .bottom-left-footer div a{text-decoration:none;font-size:11px;font-weight:700;color:#878484}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/footer/footer.mobile.scss
// module id = 522
// module chunks = 0